import seller1 from '../image/seller1.jpg';
import seller2 from '../image/seller2.jpg';
import seller3 from '../image/seller3.jpg';
import seller4 from '../image/seller4.jpg';
import seller5 from '../image/seller5.jpg';

const TopSeller = [
  { id: 1, seller_name: 'Jane Cooper', username: '@jane', imgSrc: seller1 },
  { id: 2, seller_name: 'Ariene McCoy', username: '@ariene', imgSrc: seller2 },
  { id: 3, seller_name: 'Theresa Webb', username: '@theresa', imgSrc: seller3 },
  { id: 4, seller_name: 'Ralph Edwards', username: '@ralph', imgSrc: seller4 },
  { id: 5, seller_name: 'Raplhie', username: '@raplhie', imgSrc: seller5 },
];

export default TopSeller;
